module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (132).d5fed6ab.jpg";